__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-13-1786614654-stable-dev/";